<!--For install app prompt-->
<div  class="install-prompt-container" >
  <div class="install-prompt-main">
    <div class="install-prompt-cancel" (click)="closePrompt();">
      <i class="fa fa-times"></i>
    </div>
    @switch (data) {
      @case ('3') {
        <!--for native browser-->
        <div class="install-prompt-content">
          <div class="prompt-top-section">
            <div class="prompt-top-content">
              <div class="prompt-mini-box"></div>
              <div class="prompt-mini-box"></div>
              <div class="prompt-mini-box">
                <div class="prompt-mini-box-content"><img src="{{config.icon.src}}" /></div>
              </div>
              <div class="prompt-mini-box"></div>
              <div class="prompt-mini-box"></div>
            </div>
          </div>
          <div class="prompt-middle-section">
            <div class="prompt-middle-content">
              <div class="prompt-middle-section-heading">Install {{config.name}}</div>
              <div class="prompt-middle-section-content">Install the {{config.name}} on your phone for quick & easy access on the go.</div>
            </div>
          </div>
          <div class="prompt-bottom-section">
            <div class="prompt-bottom-content">
              <div class="prompt-bottom-section-content-top">Just tap<img src="/assets/images/mob-profile-logout.svg"></div>
              <div class="prompt-bottom-section-content-bottom">scroll down to 'Add to Home Screen'</div>
            </div>
          </div>
        </div>
      }
      @case ('2') {
        <ng-template [ngTemplateOutlet]="chrome"></ng-template>
      }
      @case ('4') {
        <ng-template [ngTemplateOutlet]="safari"></ng-template>
      }
      @default {
        <ng-template [ngTemplateOutlet]="chrome"></ng-template>
      }
    }
  </div>
</div>

<ng-template #chrome >
  <!--for non-native browser-->
  <div class="install-prompt-non-native-container">
    <div class="install-prompt-non-native-main">
      <div class="install-prompt-non-native-img">
        <img src="/assets/images/logo-chrome-01.svg">
      </div>
      <div class="install-prompt-non-native-content">
        <h3>Open in Chrome</h3>
        Relaunch this website in Chrome to get quick & easy access on the go.
      </div>
    </div>
  </div>
</ng-template>
<ng-template #safari >
  <!--for non-native browser-->
  <div class="install-prompt-non-native-container">
    <div class="install-prompt-non-native-main">
      <div class="install-prompt-non-native-img">
        <img src="/assets/images/logo-safari-01.svg">
      </div>
      <div class="install-prompt-non-native-content">
        <h3>Open in Safari</h3>
        Relaunch this website in Safari to get quick & easy access on the go.
      </div>
    </div>
  </div>
</ng-template>